define(function (require, exports, module) {
    var vs = require('../vs/vs');
    var linkParser = require('../linkParser/linkParser');

    var JDAPP = "jdapp",
        JDJR = "jdjr",
        BROWSER = "browser";

    var tapEvent = {
        ua: vs.ua,
        tapItem: function (useLinkParser) {
            var self = this;

            self.handleTap(".tapItem", function (_this) {
                if ($(_this).parents("#cj-itemsList").length > 0) {
                    var url = location.href.split("#")[0];
                    history.pushState({}, "", url + "#reload");
                }

                var skuid = $(_this).attr("skuid");
                if (self.ua == JDAPP || self.ua == JDJR) {
                    location.href = self.openApp(skuid);
                } else if (self.ua == BROWSER) {
                    var itemLink=vs.setVs(self.composit4MJd(skuid, "", ""));
                    if(useLinkParser){
                      // 如果使用linkParser解析itemLink区分微信平台
                      itemLink=linkParser.parse(itemLink);
                    }
                    location.href = itemLink;
                }
            });
        },
        tapSale: function () {
            var self = this;

            self.handleTap(".tapSale", function (_this) {
                var href = $(_this).attr("data-href");

                if (self.ua == JDAPP || self.ua == JDJR) {
                    if (href.indexOf("sale.jd.hk/m") >= 0) {
                        href = href.replace("sale.jd.hk/m", "sale.jd.hk/app");
                    } else if (href.indexOf("sale.jd.com/m") >= 0) {
                        href = href.replace("sale.jd.com/m", "sale.jd.com/app");
                    }
                } else if (self.ua == BROWSER) {
                    if (href.indexOf("sale.jd.hk/app") >= 0) {
                        href = href.replace("sale.jd.hk/app", "sale.jd.hk/m");
                    } else if (href.indexOf("sale.jd.com/app") >= 0) {
                        href = href.replace("sale.jd.com/app", "sale.jd.com/m");
                    }
                }

                location.href = vs.setVs(href);
            });
        },
        tapLink: function (useLinkParser) {
            var self = this;

            self.handleTap(".tapLink", function (_this) {
                if (window.sessionStorage) {
                    var scrollTop = $("body").scrollTop();
                    sessionStorage.setItem("scrollTop", scrollTop);
                }

                // 激活分类京选对应的tabs
                var $me=$(_this);
                var $jxTabs=$me.closest('.jxTabs');
                if($me.hasClass('moreItem') && $jxTabs.length>0){
                  var matchLink="jdw.jd.hk/chooseclz/index.html";
                  var link=$(_this).attr("data-href");
                  if(link.indexOf(matchLink)!==-1){
                    location.href='//'+matchLink+'?activeCateId='+$jxTabs.find('.curr').attr('cateid');
                    return
                  }
                }

                var link=vs.setVs($(_this).attr("data-href"));
                if(useLinkParser){
                  // 如果使用linkParser解析link区分微信平台
                  link=linkParser.parse(link);
                }
                location.href = link;
            });
        },
        tapVender: function () {
            var self = this;

            self.handleTap(".tapVender", function (_this) {
                var venderId = $(_this).data('venderId');
                if (self.ua == JDAPP) {
                    location.href = self.conposeVenderLink4App(venderId);
                } else if (self.ua == BROWSER || self.ua == JDJR) {
                    href = "//shop.m.jd.com/?shopId=" + venderId;
                    location.href = vs.setVs(href);
                }

            });
        },
        handleTap: function (className, callback) {
            var self = this;
            window.canAutoScroll = true;
            var f = [];
            if (typeof(jQuery) != "undefined") {
                jQuery.noConflict();
            }

            $(className).off("touchstart").on("touchstart", function (e) {
                f.startX = e.touches[0].clientX;
                f.endX = e.touches[0].clientX;
                f.prevX = f.startX;
                f.prevY = e.touches[0].clientY;
                f.directionX = "";
                f.directionY = "";
            }).off("touchmove").on("touchmove", function (e) {
                f.directionX = e.touches[0].clientX - f.prevX > 0 ? "right" : "left";
                f.directionY = e.touches[0].clientY - f.prevY > 0 ? "bottom" : "top";
            }).off("touchend").on("touchend", function (e) {
                if (f.directionY != "top" && f.directionY != "bottom" && f.directionX != "right" && f.directionX != "left") {
                    if ($.isFunction(callback)) {
                        callback(this);
                    }
                }
            });
        },
        composit4MJd: function (sku, actId, sid) {
            var link = "//m.jd.com/product/";
            link = link + sku + ".html?";
            link = link + "resourceType=m_destination_page";
            link = link + "&resourceValue=" + actId;
            return link;
        },
        openApp: function (sku) {
            var link = 'openapp.jdMobile://virtual?params={"category":"jump","des":"productDetail","skuId":"';
            link = link + sku;
            link = link + '","sourceType":"m_destination_page","sourceValue":"","landPageId":""}';
            return link;
        },
        conposeVenderLink4App: function (shopId) {
            var link = 'openApp.jdMobile://virtual?params=';
            link += '{"category":"jump","des":"jshopMain","shopId":"' + shopId;
            link += '","sourceType":"","sourceValue":"", "landPageId":"jshop.cx.mobile"}';
            return link;
        },
        closeWebView: function () {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.indexOf(JDAPP) != -1) {
                //如果是京东app里面，根据客户端是android或者ios版本,关闭webview
                if (/iphone|ipad|ipod/.test(ua)) {
                    location.href = "objc:closeMPage";
                } else if (/android/.test(ua)) {
                    JdAndroid.finishWebActivity();
                }
            } else {
                //否则哪儿跳过来的，跳回到哪儿去，没有来源就跳回首页
                if (!document.referrer || document.referrer == "" || document.referrer == window.location.href) {
                    // location.href = "//m.jd.hk"
                    location.href = "//jdw.jd.hk"
                } else {
                    location.href = document.referrer;
                }
            }
        }
    };

    module.exports = tapEvent;
});



// WEBPACK FOOTER //
// ./src/js/unit/tapEvent/tapEvent.js